import { Injectable, signal, computed } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TimezoneService {
  private supportedZones: Record<string, string> = {
    'Asia/Kolkata': 'Asia/Kolkata',
    'Australia/Sydney': 'Australia/Sydney',
    'Asia/Manila': 'Asia/Manila'
  };

  private defaultZone: string;
  private timezoneSignal = signal<string>('');

  /** Exposed reactive timezone */
  timezone = computed(() => this.timezoneSignal());

  constructor() {
    this.defaultZone = this.detectSystemZone();
    const stored = localStorage.getItem('app_timezone');
    
    // Initialize signal: stored timezone if available, else default
    this.timezoneSignal.set(stored || this.defaultZone);

    // If nothing in storage, persist default immediately
    if (!stored) {
      localStorage.setItem('app_timezone', this.defaultZone);
    }
  }

  /** Change timezone and persist */
  setTimezone(zone: string) {
    if (this.supportedZones[zone]) {
      this.timezoneSignal.set(zone);
      localStorage.setItem('app_timezone', zone);
    } else {
      console.warn(`Unsupported timezone: ${zone}`);
    }
  }

  /** Get current timezone (signal) */
  getTimezone(): string {
    return this.timezoneSignal();
  }

  /** Detect system timezone or fallback to default supported zone */
  private detectSystemZone(): string {
    const systemZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return this.supportedZones[systemZone] || 'Asia/Kolkata';
  }
}
